import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Component from './component'
import { sBrowser } from '../../redux/modules/browser'
import { addSearchAgent } from '../../redux/modules/searchAgent'
import { sFilterChips } from '../../shared/selectors'

const WithData = connect(
  state => ({
    browser: sBrowser(state),
    filterChips: sFilterChips(state),
    isAdding: state.searchAgent.isAdding,
    locationAndObjektartIsSet:
      'location' in state.estateOverviewFilters &&
      'objektart' in state.estateOverviewFilters,
  }),
  dispatch => bindActionCreators({ addSearchAgent }, dispatch)
)(Component)

export default WithData
